import ApplicationAdapter from './application';

export default class School extends ApplicationAdapter {
  namespace = 'schools/v4';
  modelNamePlural = 'schools';
}
